import { FETCH_DONATIONHISTORY, FETCH_DONATIONHISTORY_SUCCESS, FETCH_DONATIONHISTORY_FAILURE } from '../actions';

const initialState = {
  donationhistory: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_DONATIONHISTORY:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_DONATIONHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        donationhistory: action.data
      };
    case FETCH_DONATIONHISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        donationhistory: {}
      };
    default:
      return state;
  }
}